/* eslint-env browser */

// see https://www.npmjs.com/package/debug
if (localStorage) {
  localStorage.debug = '*'
}
import('./script.js')
